// onclick js-videoPlay
document.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll('.js-videoHolder').forEach(function(item) {
        const video = item.querySelector('.js-video');
		const videoPlay = item.querySelector('.js-videoPlay');
        const cardTitle = item.querySelector('.js-cardTitle');
        
		if (!videoPlay) {
			return;
		}
		videoPlay.addEventListener('click', function() {
			video.setAttribute('aria-hidden', 'false');
            cardTitle.setAttribute('aria-hidden', 'true');
            videoPlay.setAttribute('aria-hidden', 'true');

			video.play();

            video.classList.add('-active');
            cardTitle.classList.add('-hidden');
            videoPlay.classList.add('-hidden');
			
		});
	});
});